import React from 'react';
import { useHistory } from 'react-router-dom';
import SupportBlock from 'components/common/SupportBlock';
import SubtitleWithLines from 'components/common/SubtitleWithLines';
import { MessageStyled, LoginButtonStyled, TitleStyled } from './styles';

const ExistingUserFallback: React.FC = () => {
  const history = useHistory();

  const redirectToLoginPage = (): void => {
    history.push('/login');
  };

  return (
    <>
      <TitleStyled>You&apos;re Almost There</TitleStyled>
      <MessageStyled>
        You&apos;ve already been invited to the platform. If you&apos;ve completed your registration, please sign in to
        continue.
      </MessageStyled>

      <LoginButtonStyled size="large" color="primary" onClick={redirectToLoginPage}>
        Go to Sign In
      </LoginButtonStyled>
      <SubtitleWithLines text="Still need to register?" />
      <SupportBlock type="PENDING_REGISTRATION" />
    </>
  );
};

export default ExistingUserFallback;
